import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  leaderBoard: {},
  leaderboardFilters: {
    teams: [],
    roles: [],
    departments: [],
    divisions: [],
  },
}

const leaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    setLeaderBoard: (state, action) => {
      state.leaderBoard = action.payload
    },
    setLeaderboardFilters: (state, action) => {
      state.leaderboardFilters.departments = action.payload.departments
      state.leaderboardFilters.divisions = action.payload.divisions
      state.leaderboardFilters.roles = action.payload.roles
      state.leaderboardFilters.teams = action.payload.teams
    },
  },
})

export const { setLeaderBoard, setLeaderboardFilters } = leaderboardSlice.actions
export default leaderboardSlice.reducer
